"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.audioVideoDidStartHandler = audioVideoDidStartHandler;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _logger = require("../../../constants/logger");
var logger = new _StudioLogger.StudioLogger(_logger.loggerName);
function audioVideoDidStartHandler(meetingSession, meetingResponse, attendeeResponse, hasLocalTile) {
  if (hasLocalTile) {
    /*
    We've been getting this error ChimeMeetingLogger - no video device chosen, stopping local video tile
    Looking at the chime sdk issue, i noticed we were doing the same thing which was called out here
    https://github.com/aws/amazon-chime-sdk-js/issues/1818#issuecomment-975774752
    by calling the startLocalVideoTile in the createLocalSource action,
    it sometimes creates a race condition which causes the chime logger error above to occur.
    AWS's recommended way to achieve this is to add the audioVideoDidStart observer and then call startlocalVideoTile function.
    this ensures the meeting session is successfully established before calling the startlocalVideoTile function
    */
    meetingSession.audioVideo.startLocalVideoTile();
  }

  // Log meeting started
  var meetingId = meetingResponse.Meeting.MeetingId;
  var attendeeId = attendeeResponse.Attendee.AttendeeId;
  var logPayload = {
    chimeEventName: 'audioVideoDidStart',
    'studio.meeting.id': meetingId,
    title: "Meeting ".concat(meetingId, " started for attendee ").concat(attendeeId)
  };
  logger.info(logPayload.title, logPayload);
}